import React from "react";
import { graphql } from "gatsby";
// import { GatsbyImage } from "gatsby-plugin-image";
import { RichText } from "../../utils/richText";
// import { motion } from "framer-motion";
// import { FADE_UP, STAGGER, useInView, combine } from "../animationUtils";

export const fragments = graphql`
  fragment Page_SolutionBlade on PrismicPageDataBodySolutionBlade {
    id
    primary {
      full_width
      description {
        html
        richText
      }
      eyebrow
      title1 {
        richText
        html
        text
      }
    }
  }
  fragment FocusArea_SolutionBlade on PrismicFocusAreaDataBodySolutionBlade {
    id
    primary {
      full_width
      description {
        html
        richText
      }
      eyebrow
      title1 {
        richText
        html
        text
      }
    }
  }
  fragment Homepage_SolutionBlade on PrismicHomepageDataBodySolutionBlade {
    id
    primary {
      full_width
      description {
        html
        richText
      }
      eyebrow
      title1 {
        richText
        html
        text
      }
    }
  }
  fragment MediumPost_SolutionBlade on PrismicMediumPostDataBodySolutionBlade {
    id
    primary {
      full_width
      description {
        html
        richText
      }
      eyebrow
      title1 {
        richText
        html
        text
      }
    }
  }
  fragment Project_SolutionBlade on PrismicProjectDataBodySolutionBlade {
    id
    primary {
      full_width
      description {
        html
        richText
      }
      eyebrow
      title1 {
        richText
        html
        text
      }
    }
  }
  fragment TeamMember_SolutionBlade on PrismicTeamMemberDataBodySolutionBlade {
    id
    primary {
      full_width
      description {
        html
        richText
      }
      eyebrow
      title1 {
        richText
        html
        text
      }
    }
  }
`;

function SolutionBlade({ data }) {
  const { eyebrow, title1, description, full_width } = data?.primary;
  const _id = "solution-blade";
  return (
    <div className={`${_id} ${full_width ? '' : 'narrow'}`}>
      <div className={`container`}>
        <div className={`${_id}__header-container`}>
          {eyebrow && <h5 className={`${_id}__eyebrow`}>{eyebrow}</h5>}
          {title1 && <div className={`${_id}__title`}>{RichText(title1?.richText)}</div>}
        </div>
        {description && <div className={`${_id}__description`}>{RichText(description?.richText)}</div>}
      </div>
    </div>
  );
}

export default SolutionBlade;
